import axios from 'axios';
import { Component } from 'react';
import './MyWorkDetails.css'

class MyWorkDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      closeClassName: 'far fa-times-circle',
      selProjectData: [],
      loading: false,
      line1: 'Loading . . .',
      textAnimationLine1: [],
      countDownLoading: 0,
      loadingAni: false
    }
  }

  async componentDidMount() {
    if (this.props.Selected) {
      await axios.get(this.props.valueMyWork).then((data) => {
        this.setState({
          selProjectData: data.data,
          loading: true
        })
      })
    }
    let mArr = []
    for (var i = 0; i < 20; i++) {
      mArr[i] = { letterAni: 0 }
    }
    this.setState({
      textAnimationLine1: mArr
    })
    setInterval(() => {
      if (this.state.countDownLoading <= 13 && !this.state.loadingAni) {
        mArr[this.state.countDownLoading] = { letterAni: 1 }
        this.setState({
          textAnimationLine1: mArr,
          countDownLoading: this.state.countDownLoading + 1
        })
      } else {
        this.setState({
          loadingAni: true
        })
        mArr[this.state.countDownLoading] = { letterAni: 0 }
        this.setState({
          textAnimationLine1: mArr,
          countDownLoading: this.state.countDownLoading - 1
        })
        if (this.state.countDownLoading === 0) {
          mArr[0] = { letterAni: 0 }
          this.setState({
            textAnimationLine1: mArr,
          })
        }
      }
    }, 100)
  }

  render() {
    return (<>
      <div className='MainDivisionPopUp'>
        {this.state.loading && this.state.loadingAni ?
          <div className='PopUpDivisionLoaded'>
            <div className='PopUpStartDivision'>
              <div className='popUpDivisionHeading'>
                {this.state.selProjectData[0].projectname}
              </div>
              <i className={this.state.closeClassName + ' popUpCloseWindow'} onMouseEnter={() => {
                this.setState({
                  closeClassName: 'fas fa-times-circle'
                })
              }} onMouseLeave={() => {
                this.setState({
                  closeClassName: 'far fa-times-circle'
                })
              }} onClick={() => {
                this.props.closePopUp(true)
              }}></i>
            </div>
            <div className='popUpContentDiv'>
              <img className='popUpDivisionImage' src={`https://drive.google.com/uc?export=view&id=${this.state.selProjectData[0].projectImage}`} alt={this.state.selProjectData[0].projectname} />
              <p className='popUpContentDivPara'>{this.state.selProjectData[0].projectdescription}</p>
              <a className='PopUpProjectLink' target="_blank" rel='noreferrer noopener' href={this.state.selProjectData[0].projectlink}>
                {this.state.selProjectData[0].projectname}
              </a>
            </div>
          </div>
          :
          <div className='LoadingDivPopUp'>
            <div className="LoadingMainDivision">
              <h2 className='Logo-1SelLoading'>S</h2>
              <div className="LoadingDivText">{this.state.line1.split('').map((ite, index) => {
                return (<>
                  <span className={this.state.textAnimationLine1[index]?.letterAni === 0 ? 'LetterAniLoadingHidn' : 'LetterAniLoading'}>{ite}</span>
                </>)
              })}</div>
            </div>
          </div>}
      </div>
    </>);
  }
}

export default MyWorkDetails;